import React, { PureComponent } from 'react';

export default function withPure(Comp) {
  return class extends PureComponent {
    render() {
      return <Comp {...this.props} />;
    }
  };
}
